import { render, staticRenderFns } from "./ListaSistema.vue?vue&type=template&id=50c8dbaa&scoped=true&"
import script from "./ListaSistema.vue?vue&type=script&lang=js&"
export * from "./ListaSistema.vue?vue&type=script&lang=js&"
import style0 from "./ListaSistema.vue?vue&type=style&index=0&id=50c8dbaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8dbaa",
  null
  
)

export default component.exports